import SalesChallengeMassiveUpload from './containers/SalesChallengeMassiveUpload';
export default SalesChallengeMassiveUpload;
